module.exports = __webpack_public_path__ + "static/media/magnum-3x.c1c12753.png";